import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBanList = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M18.714 15.347a4.261 4.261 0 0 1 4.256 4.256 4.261 4.261 0 0 1-4.256 4.256 4.261 4.261 0 0 1-4.256-4.256 4.261 4.261 0 0 1 4.256-4.256ZM12.608 1.86a6.395 6.395 0 0 1 6.389 6.39 6.369 6.369 0 0 1-1.836 4.477l-.077.07.487.254.457.27a.884.884 0 0 1-.936 1.499 8.439 8.439 0 0 0-.964-.519l-.502-.21-.252-.085-.4.179a6.335 6.335 0 0 1-1.393.38l-.483.055-.49.019a6.354 6.354 0 0 1-2.372-.457l-.411-.184-.134.047a8.436 8.436 0 0 0-5.593 7.523l-.01.445a.884.884 0 1 1-1.77 0 10.18 10.18 0 0 1 5.495-9.07l.308-.149a6.372 6.372 0 0 1-1.903-4.545 6.395 6.395 0 0 1 6.39-6.389Zm3.781 18.625.042.11a2.492 2.492 0 0 0 2.283 1.497 2.492 2.492 0 0 0 2.28-1.488l.043-.117-4.648-.002Zm2.325-3.368a2.492 2.492 0 0 0-2.28 1.491l-.045.11h4.646l-.039-.104a2.494 2.494 0 0 0-2.011-1.483l-.271-.014ZM12.608 3.628a4.626 4.626 0 0 0-4.622 4.621 4.626 4.626 0 0 0 4.622 4.622 4.625 4.625 0 0 0 4.62-4.622 4.626 4.626 0 0 0-4.62-4.621Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgBanList)
const Memo = memo(ForwardRef)
export default Memo
